import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export const bigWinStore = Store.createStore({
    big_win_thresholds: Store.signal({
        amazing: 20,
        incredible: 50,
        awesome: 100
    } as Record<string, number>),

    big_win_threshold: Store.signal(20),
    big_win_width: Store.signal(3840),
    big_win_height: Store.signal(2040),
});